import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface SocioRelationalAssessmentResult {
  id: string;
  assessmentType: string;
  selectedCategory: number;
  scores: {
    overall: number;
    socioRelationalScore: number;
    subscales?: {
      significantOther: number;
      family: number;
      friends: number;
    };
  };
  results: {
    level: 'Low' | 'Moderate' | 'High';
    interpretation: string;
    recommendations: string[];
  };
  createdAt: string;
}

const SocioRelationalAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const assessmentResult = location.state?.assessmentResult as SocioRelationalAssessmentResult;

  if (!assessmentResult || !assessmentResult.scores || !assessmentResult.results) {

    navigate('/panel/learn/');
    return null;
  }

  try {
    // Detect MSPSS by selectedCategory or by interpretation string (backend fallback)
    const isMSPSS = assessmentResult.selectedCategory === 2 ||
      (assessmentResult.results?.interpretation && assessmentResult.results.interpretation.includes('Multidimensional Scale of Perceived Social Support'));

    const config = createAssessmentConfig(
      {
        ...assessmentResult,
        selectedCategory: isMSPSS ? 2 : 1 // force correct category for frontend logic
      },
      {
        assessmentType: 'socio-relational',
        assessmentName: 'socio-relational-assessment',
        assessmentDisplayName: isMSPSS ? 'MULTIDIMENSIONAL SCALE OF PERCEIVED SOCIAL SUPPORT' : 'GENDER SENSITIVITY STAR ASSESSMENT',
        redoRoute: '/panel/learn/socio-relational-assessment',
        completeRoute: '/panel/insights',
        scoreLabel: isMSPSS ? 'Social Support Score' : 'Socio-Relational Score',
        subtitleMapping: isMSPSS ? {
          High: 'High Social Support',
          Moderate: 'Moderate Social Support',
          Low: 'Low Social Support (Support Needed)'
        } : {
          High: 'High Social Acceptance & Support',
          Moderate: 'Moderate Social Acceptance',
          Low: 'Low Social Acceptance (Support Needed)'
        },
        visualMessage: "You've completed the assessment!",
        resultsTitle: isMSPSS ? "Here's your social support analysis" : "Here's your gender sensitivity analysis"
      }
    );

    return <AssessmentCompletionTemplate config={config} />;
  } catch (error) {

    navigate('/panel/learn/');
    return null;
  }
};

export default SocioRelationalAssessmentCompletionPage;



